import { InnerBlocks, RichText, useBlockProps } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import React from 'react';

interface SaveProps {
  attributes: {
    imageSrc?: string;
    imageAlt?: string;
    imageId?: number;
    kicker?: string;
    headline?: string;
    buttonText?: string;
    url?: string;
    opensInNewTab?: boolean;
  };
}

const Save: React.FC<SaveProps> = ({ attributes: { imageSrc, imageId, imageAlt, headline, kicker, url, opensInNewTab } }) => {
  const renderImage = () =>
    imageSrc && (
      <figure className="card__image">
        <img src={imageSrc} alt={imageAlt} className={`card-image wp-image-${imageId}`} />
      </figure>
    );

  return (
    <div {...useBlockProps.save()}>
      {renderImage()}
      <header className="card__header">
        {kicker && <p className="card__kicker">{kicker}</p>}
        <RichText.Content tagName="h2" className="card__title" value={headline} />
      </header>
      <div className="card__body">
        <InnerBlocks.Content />
      </div>

      {url && (
        <footer className="card__footer">
          <a
            aria-label={`${__('Weiterlesen auf')} ${headline}`}
            className="card__button"
            href={url}
            target={opensInNewTab ? '_blank' : undefined}
            rel={opensInNewTab ? 'noopener noreferrer' : undefined}
          >
            <span className="card__button-label">{__('Weiterlesen')}</span> <i className="fa-solid fa-arrow-right"></i>
          </a>
        </footer>
      )}
    </div>
  );
};

export default Save;
